import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'

// Публикация документа: снимает черновик (односторонне). Инвалидация — весь
// namespace документов (detail + листинг владельца).
export function usePublishDocument(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiRequest({ method: 'POST', url: `/documents/${documentId}/publish` }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['document'] })
    },
  })
}
